export const noDeclarations = (state) => state.declarations.length === 0
